export const footerContent = {
  rayaldee: "RAYALDEE",
  text: " is a registered trademark of Eirgen Pharma Ltd. OPKO Renal is adivision of OPKO Health, Inc. © 2023 OPKO Pharmaceuticals, LLC. All rights reserved. OP-US-0649-092022v.1",
};
